import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ExpandMoreIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >expand_more</MuiIcon>
    );
}
